export function getString(date: Date) {
  let year = date.getFullYear().toString();
  let month = (1 + date.getMonth()).toString();
  let day = date.getDate().toString();
  let hour = date.getHours().toString();
  let minute = date.getMinutes().toString();
  let second = date.getSeconds().toString();
  
  month = ('0' + month).slice(-2);
  day = ('0' + day).slice(-2);
  hour = ('0' + hour).slice(-2);
  minute = ('0' + minute).slice(-2);
  second = ('0' + second).slice(-2);
  
  let format = 'YYYY-MM-DD hh:mm:ss';
  format = format.replace(/YYYY/g, year);
  format = format.replace(/MM/g, month);
  format = format.replace(/DD/g, day);
  format = format.replace(/hh/g, hour);
  format = format.replace(/mm/g, minute);
  format = format.replace(/ss/g, second);
 
  return format;
}